import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/operator.png'


const _hoisted_1 = { class: "evse evse-details details" }
const _hoisted_2 = { class: "detail-top" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = { class: "section-header__block" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    height: "48"
  })
], -1)
const _hoisted_6 = { class: "info-tags" }
const _hoisted_7 = { class: "app-wrapper" }

import { computed } from 'vue'
import { ElMessageBox as MB, ElMessage } from 'element-plus'
import { Edit } from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
import DetailHeader from '@/components/DetailHeader.vue'
import Overview from '@/views/Dashboard/HomeStyleEn.vue'
import { getOperatorInfo, banOperator } from '@/api/operation'
import { checkMenuShow } from '@/store/tool'
import { Country } from '@/types/types'
import OperatorUpsert, { OperationType } from './components/OperatorUpsert.vue'
import OperatorTerminalApp from './components/OperatorTerminalApp.vue'
import OperatorNoti from './components/OperatorNoti.vue'
import OperatorPaymnetChannel from './components/OperatorPaymnetChannel.vue'
import useProtocolEnums from '@/hooks/useProtocolEnums'

import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent, ref, Ref } from 'vue'
const __default__ = defineComponent({
  name: 'OperatorDetail',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('Evses')

const { getCountry, getCurrency, getCurrencySymbol } = useProtocolEnums()

const route = useRoute()
const operatorid = computed(function () {
  return route.params.id
})
const operator = ref<Record<string, any>>({
  id: operatorid,
})
const showDialog = ref(false)
const showOperatorType: Ref<OperationType> = ref('edit')
const operatorDetailLock = ref(false)
const currTab = ref('overview')

const handleTabChange = (tabname: any) => {
  console.log('tabname', tabname)
}
const editOperator = () => {
  showDialog.value = true
}

const loadData = async function () {
  getOperatorInfo({
    operatorID: operatorid.value,
  })
    .then((res: any) => {
      operator.value = res.operator
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
    })
}
const updateEnable = () => {
  banOperator(operator.value.id, operator.value.isOpen)
}

const initData = async () => {
  await loadData()
}

initData()

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DetailHeader, {
        item: { name: operator.value.name }
      }, null, 8, ["item"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, [
              (operator.value.company)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "primary",
                    effect: "plain",
                    size: "small",
                    hit: false,
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(operator.value.company), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (operator.value.country)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "primary",
                    effect: "plain",
                    size: "small",
                    hit: false,
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getCountry)(operator.value.country)), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (operator.value.currency)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 2,
                    type: "primary",
                    effect: "plain",
                    size: "small",
                    hit: false,
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getCurrency)(operator.value.currency)) + " " + _toDisplayString(_unref(getCurrencySymbol)(operator.value.currency)), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_tooltip, {
            content: operator.value.banned ? _ctx.$t('Base.disable') : _ctx.$t('Base.enable'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                class: "enable-btn",
                disabled: !_ctx.$hasPermission('post'),
                modelValue: operator.value.banned,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((operator.value.banned) = $event)),
                onChange: updateEnable
              }, null, 8, ["disabled", "modelValue"])
            ]),
            _: 1
          }, 8, ["content"]),
          _createVNode(_component_el_tooltip, {
            content: _ctx.$t('Base.edit'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "icon-button",
                disabled: !_ctx.$hasPermission('post'),
                type: "primary",
                icon: _unref(Edit),
                plain: "",
                size: "small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (editOperator()))
              }, null, 8, ["disabled", "icon"])
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_tabs, {
      class: "detail-tabs",
      modelValue: currTab.value,
      "onUpdate:modelValue": [
        _cache[2] || (_cache[2] = ($event: any) => ((currTab).value = $event)),
        handleTabChange
      ]
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(), _createBlock(_component_el_tab_pane, {
            label: _ctx.$t('Base.overview'),
            name: "overview",
            lazy: true,
            key: 'overview'
          }, {
            default: _withCtx(() => [
              _createVNode(Overview, {
                operatorId: operator.value.id,
                style: {"padding-left":"0px","padding-right":"0px"}
              }, null, 8, ["operatorId"])
            ]),
            _: 1
          }, 8, ["label"]))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])), [
      [
        _directive_loading,
        operatorDetailLock.value,
        void 0,
        { lock: true }
      ]
    ]),
    _createVNode(OperatorUpsert, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showDialog).value = $event)),
      operationType: showOperatorType.value,
      operatorInfo: operator.value,
      onSubmitted: loadData
    }, null, 8, ["modelValue", "operationType", "operatorInfo"])
  ]))
}
}

})